import React from "react";
import BlueHero from "../../../assets/images/fullNameHero.svg";
import { useNavigate } from "react-router-dom";

const HS = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        className="h-dvh bg-cover bg-center"
        style={{ backgroundImage: `url(${BlueHero})` }}
      >
        <div className="flex items-center container mx-auto h-full">
          <div className="flex lg:w-1/2 w-full flex-col">
            <h1 className="text-white text-5xl font-medium leading-tight">
              Developing a <span className="text-mustardYellow">Daily</span>
              <br />
              and <span className="text-mustardYellow">Systematic</span> Bible
              <br />
              Reading <span className="text-mustardYellow">Discipline</span>
            </h1>

            <button className="mt-16 px-8 py-3 bg-textBlue hover:bg-opacity-90 transition-all text-base rounded-full w-fit" onClick={() => navigate("/cbr-program")}>
              How CBR Works
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HS;
